<template>
  <div class="testimonials-panel">
    <div class="ba big-left-arrow" v-on:click="slideRightClick"></div>
    <div class="testimonial-scroller" v-if="quotes">
      <div class="wide-holder" :style="'transform: translateX(' + curleft + '%)'" :class="{hidden: hidden}">
        <div class="t-holder" v-for="item in quotes" :key="'ts_' + item.testimonial_id + '_' + item.from">
          <div class="testimonial">
            <div class="quote-holder" v-if="item">
              <div class="quote open"></div>
              <div class="quote-text" :class="getFontSize(item)">
                {{ item.quote }}
              </div>
              <div class="quote close"></div>
            </div>
            <div class="quote-name">{{ formatName(item) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="ba big-right-arrow" v-on:click="slideLeftClick"></div>
  </div>
</template>

<script>
export default {
  props: {
    artist: String
  },
  data () {
    return {
      quotes:[],
      currentQuoteNumber: 0,
      currentQuote: {},
      currentClass: '',
      timeoutId: 0,
      curleft: 0,
      hidden: false
    }
  },
  created () {
    this.loadData()
  },
  mounted () {
    this.startMoving()
  },
  methods: {
    startMoving: function () {
      this.timeoutId = window.setInterval(() => {
        this.slideLeft()
      }, 4000)
    },
    getFontSize: function (item) {
      if(item) {
        if(item.quote) {
          let len = item.quote.length
          if(len < 200) {
            return 'large'
          }
          else if(len > 600){
            return 'small'
          }
        }
      }
      
      return ''
    },
    formatName: function (quote) {
      if(quote) {
        if(quote.from === 'artist'){
          return quote.name + ' ' +  quote.company
        }
        else {
          let ret = quote.name
          if(quote.company) {
            ret += ', ' + quote.company
          }
          return ret
        }
      }
      return ''
    },
    loadData: async function () {
      let res = []
      this.currentQuoteNumber = 0
      if(this.artist) {
        res = await this.$apix.get('collections/testimonials/artist/' + this.artist)
      }
      else {
        res = await this.$apix.get('collections/testimonials/get')
      }
      this.quotes = this.$k.shufffleCopyObjectArray(res.data)
      if(this.quotes.length < 1) {
        this.$emit('empty', true)
        return
      }
      this.currentQuote = this.quotes[0]
      this.$emit('empty', false)
    },
    slideRightClick: async function () {
      window.clearInterval(this.timeoutId)
      await this.slideRight()
    },
    slideLeftClick: async function () {
      window.clearInterval(this.timeoutId)
      await this.slideLeft()
    },
    slideLeft: async function () {
      
      this.currentQuoteNumber++
      if(this.currentQuoteNumber >= this.quotes.length){
        this.currentQuoteNumber = 0
        this.hidden = true
        await this.$k.waitfor(400)
      }
      
      this.curleft = -this.currentQuoteNumber * 100
      await this.$k.waitfor(200)
      this.hidden = false
      
      
    },
    slideRight: async function () {
      
      this.currentQuoteNumber--
      if(this.currentQuoteNumber < 0 ){
        this.currentQuoteNumber = this.quotes.length - 1
        this.hidden = true
        await this.$k.waitfor(400)
      }
      this.curleft = -this.currentQuoteNumber * 100
      await this.$k.waitfor(300)
      this.hidden = false
    }
  },
  beforeDestroy () {
    window.clearInterval(this.timeoutId)
  },
  watch: {
    artist () {
      this.loadData()
    }
  }
}
</script>

<style scoped>
.testimonials-panel{
  background-color:#efefea;
  padding:45px;
  display:flex;
  justify-content:space-between;
  min-height:200px;
}

.ba{
  background-size: 70%;
  background-position: center center;
  width:10%;
  cursor:pointer;
}

.big-left-arrow{
  background-image:url('../../assets/img/arrow-left-white.svg');
}

.big-right-arrow{
  background-image:url('../../assets/img/arrow-right-white.svg');
}

.testimonial-scroller{
  position:relative;
  max-width:80%;
  overflow:hidden;
}

.wide-holder{
  display:flex;
  transition:all 0.5s ease;
  min-height:100%;
}

.wide-holder.hidden{
  opacity:0;
}

.t-holder{
  width:100%;
  min-width:100%;
  display:flex;
  flex-direction: column;
  justify-content: center;
}
.testimonial{
  opacity:1;
}

.quote-holder{
  display:flex;
  align-items:stretch;
  justify-content:center;
}

.testimonial.dotrans{
  transition: all 0.3s ease;;
}

.testimonial.slidleft
{
  opacity:0;
  transform: translateX(-500px);
}

.testimonial.slidright{
  opacity:0;
  transform: translateX(500px);
}

.testimonial .quote{
  width:65px;
  background-size: contain;
}

.testimonial .quote.open{
  background-image:url('../../assets/img/quote-left.svg');
  background-position:center top;
}

.testimonial .quote.close{
  background-image:url('../../assets/img/quote-right.svg');
  background-position:center bottom;
}

.quote-text{
  width:65%;
  margin:0 16px;
  text-align:center;
  font-size:18px;
  line-height:24px;
}

.quote-text.large{
  font-size:24px;
  line-height:32px;
}

.quote-text.small{
  font-size:15px;
  line-height:21px;
}

.quote-name{
  text-align:center;
  font-weight:700;
  color:#6d6d64;
  font-size:21px;
  line-height:28px;
  margin-top:20px;
}

@media screen and (max-width:767px){

  .testimonial-scroller{
    max-width:100%;
  }

  .ba{
    display:none;
  }

  .quote-text{
    width:90%;
  }

  .testimonials-panel{
    padding:12px;
    position:relative;
  }



  .t-holder{
    width:100%;
    min-width:100%;
    max-width:none;
  }

  .quote-name{
    font-size:14px;
  }

  .quote-text{
    font-size:16px;
  }

  .quote-text.small{
    font-size:12px;
  }

  .quote-text.large{
    font-size:18px;
  }
}
</style>
